import { Component, Element, Event, EventEmitter, h, Prop, State } from '@stencil/core';
import { LANGUAGES, TRANSLATIONS } from '../../utils';
import { CategoryFilterItem } from './exports';

@Component({
  tag: 'category-filter',
  styleUrl: 'category-filter.scss',
  shadow: true,
})
export class Categoryfilter {
  @Element()
  host: HTMLCategoryFilterElement;

  @Prop()
  language: keyof typeof LANGUAGES = 'de';

  @Prop({ reflect: true })
  showFilters: boolean = false;

  @Event()
  categorySelected: EventEmitter<{ category: string[] }>;

  @State()
  selectedCategory: string[] = ['clothing', 'household', 'stationery'];

  @Prop()
  mobileWidth: boolean = false;

  private CATEGORY_FILTER_ITEMS: CategoryFilterItem[] = [
    {
      label: TRANSLATIONS[this.language].clothing,
      svg: <clothing-icon />,
      category: 'clothing',
    },
    {
      label: TRANSLATIONS[this.language].household,
      svg: <household-icon />,
      category: 'household',
    },
    {
      label: TRANSLATIONS[this.language].stationery,
      svg: <stationery-icon />,
      category: 'stationery',
    },
  ];

  private handleCategorySelection(category: string) {
    const updatedSelection = this.selectedCategory.includes(category)
      ? this.selectedCategory.filter((c) => c !== category)
      : [...this.selectedCategory, category];

    //Ensures that at least one category is always selected
    if (updatedSelection.length === 0) {
      return;
    }

    this.selectedCategory = updatedSelection;
    this.categorySelected.emit({ category: this.selectedCategory });
  }
  private toggleFilterVisibility = () => {
    this.showFilters = !this.showFilters;
  };

  private get iconButton() {
    return this.host.shadowRoot?.querySelector('mdx-icon-button');
  }
  componentDidRender() {
    this.iconButton?.addEventListener('click', this.toggleFilterVisibility);
  }

  disconnectedCallback() {
    this.iconButton?.removeEventListener('click', this.toggleFilterVisibility);
  }

  render() {
    return this.showFilters ? (
      <nav class={`category-filter ${this.mobileWidth && 'mobile'}`} data-test-id="category-filter">
        <ul class={`category-filter__list ${this.mobileWidth && 'mobile'}`}>
          {this.CATEGORY_FILTER_ITEMS.map(({ label, svg, category }) => (
            <li class="category-filter__list__item" data-test-id={`category-filter--${category}`}>
              <button
                class={`category-filter__list__item-button ${category} ${this.selectedCategory.includes(category) ? 'selected' : ''} ${this.mobileWidth && 'mobile'}`}
                onClick={() => this.handleCategorySelection(category)}
              >
                <span class="category-filter__list__item-icon">{svg}</span>
                <span class={`category-filter__list__item-label ${this.mobileWidth && 'mobile'}`}>{label}</span>
              </button>
            </li>
          ))}
        </ul>
        <div class="category-filter__hide-button">
          <mdx-icon-button size="md" variant="tertiary">
            <mdx-icon-x />
          </mdx-icon-button>
        </div>
      </nav>
    ) : (
      <div class={`category-filter--hidden ${this.mobileWidth && 'mobile'}`} data-test-id="category-filter">
        <mdx-icon-button size="md" variant="tertiary">
          <mdx-icon-filter />
        </mdx-icon-button>
      </div>
    );
  }
}
